import { ITypedAPITarget } from "./NetworkStapler";
import { ISignInfoResponse } from "types/signing";
import { SupportedLocales } from "config";
import { IAccount } from "types/account";

export function getPocketsPreContractDocument(accountId: string, language: SupportedLocales): ITypedAPITarget<{ content: string }> {
    return {
        url: `/account-documents/rest/netbanking/my/document/pre_einlsubz`,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: {
            accountId,
            language: language.toUpperCase(),
            outputFormat: "pdf"
        },
        method: "POST",
        parse: (json: any) => {
            return json as { content: string };
        }
    };
}

export function postPocketsActivation(accountId: string): ITypedAPITarget<ISignInfoResponse> {
    return {
        url: `/account-savings/rest/netbanking/my/activate_goals`,
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: {
            accountId
        },
        method: "POST",
        parse: (json: any) => {
            return json as ISignInfoResponse;
        }
    };
}

export function getAccount(accountId: string): ITypedAPITarget<IAccount> {
    return {
        url: `/proxy/g/api/my/accounts/${accountId}`,  //"/proxy/g/api/my/accounts"
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        method: "GET",
        parse: (json: any) => {
            return json as IAccount;
        }
    };
}

export function getSavingsOffersDetails(productId: string, conditionsGroupId: string): ITypedAPITarget<any> {
    return {
        url: `/proxy/g/api/my/offers/${productId}/${conditionsGroupId}`,
        headers: {
            "Accept": "application/json",
        },
        method: "GET",
        parse: (json: any) => {
            return json;
        }
    };
}




// WEBPACK FOOTER //
// ./src/network/AccountAPI.ts